<template>
  <div>
    <div class="pipeline-background">
      <NEWPipelineComponent :statuses="otherStatuses" />
      <NEWPipelineComponent :statuses="statusAll" />
    </div>
    <ConstructionAndEventPowerOverviewTable
      :journey-selection="journeySelection"
      @journey-change="setJourneyFilter"
    />
  </div>
</template>

<script>
import { NEWPipelineComponent } from '@newnetzportal/netzportal-webapp-storybook-components';
import {
  getCommissioningPipelineStatusAmount,
  getCommissioningPipelineStatusesConfig,
} from '../../helpers/commissioningStatuses';
import { getCommissioningPipelineSummary } from '../../services/CommissioningService';
import ConstructionAndEventPowerOverviewTable from './ConstructionAndEventPowerOverviewTable.vue';

import { CONSTRUCTION_AND_EVENT_POWER_JOURNEY_TYPES } from '../../helpers/constructionAndEventPowerJourneys';

export default {
  name: 'ConstructionAndEventPowerOverviewComponent',
  components: {
    ConstructionAndEventPowerOverviewTable,
    NEWPipelineComponent,
  },
  props: {
    journeySelection: { type: String, default: 'all' },
  },
  data() {
    return {
      pipelineSummary: {},
      journeyTypes: CONSTRUCTION_AND_EVENT_POWER_JOURNEY_TYPES,
      pipelineStatuses: getCommissioningPipelineStatusesConfig(),
    };
  },
  computed: {
    groupedStatusAmounts() {
      return this.pipelineStatuses.map((status) => ({
        ...status,
        amount: getCommissioningPipelineStatusAmount(
          this.pipelineSummary,
          status
        ),
      }));
    },
    groupedStatusesTotal() {
      return this.groupedStatusAmounts.reduce(
        (total, status) => total + status.amount,
        0
      );
    },
    pipelineTotal() {
      return (
        Number(this.pipelineSummary.count_orders) || this.groupedStatusesTotal
      );
    },
    otherStatuses() {
      return this.groupedStatusAmounts.map((status) => ({
        name: status.label,
        color: status.color,
        amount: status.amount,
        percentage: this.pipelineTotal
          ? (status.amount / this.pipelineTotal) * 100
          : 0,
      }));
    },
    statusAll() {
      return [
        {
          name: 'alle',
          color: '#999999',
          amount: this.pipelineTotal,
          percentage: 100,
        },
      ];
    },
  },
  methods: {
    setJourneyFilter(value) {
      this.$emit('journey-change', value);
      this.journeyTypes =
        value === 'all' ? CONSTRUCTION_AND_EVENT_POWER_JOURNEY_TYPES : [value];
      this.getOrdersSummaryForPipeline();
    },
    async getOrdersSummaryForPipeline() {
      try {
        this.pipelineSummary =
          (await getCommissioningPipelineSummary('', this.journeyTypes)) || {};
      } catch (error) {
        console.error(
          'Error fetching construction and event power pipeline summary:',
          error
        );
        this.pipelineSummary = {};
      }
    },
  },
};
</script>
